module.exports = __webpack_public_path__ + "img/btn_menu_yj.1d5f53ba.png";